"use client";
import { FormTextField, FormTextArea, FormCheckbox, FormSingleSelect, FormMultiSelect } from "./internal/components.js";
function formInputs() {
  const TextField = FormTextField;
  const TextArea = FormTextArea;
  const Checkbox = FormCheckbox;
  const SingleSelect = FormSingleSelect;
  const MultiSelect = FormMultiSelect;
  return {
    TextField,
    TextArea,
    Checkbox,
    SingleSelect,
    MultiSelect
  };
}
export {
  formInputs
};
